import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function EmotionalHook() {
  return <section className="relative z-10 px-6 py-16 md:py-24" data-id="element-30">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-3xl mx-auto glass-card p-8 md:p-12" data-id="element-31">
        <div className="flex items-center justify-center mb-8" data-id="element-32">
          <Star className="w-8 h-8 text-gold fill-gold/20" data-id="element-33" />
        </div>

        <div className="space-y-6 text-lg md:text-xl leading-relaxed font-body text-warmWhite" data-id="element-34">
          <p data-id="element-35">
            Como mamá o papá, sabes que las palabras que tus hijos escuchan hoy
            se convierten en su voz interna mañana.
          </p>
          <p data-id="element-36">
            A veces, entre las prisas del colegio y las rutinas, olvidamos lo
            más importante: enseñarles a creer en sí mismos. Queremos que sean
            valientes, que se sientan amados y que sepan que, aunque se
            equivoquen, siempre pueden volver a intentarlo.
          </p>
          <p className="text-xl md:text-2xl font-semibold text-center text-gold mt-8 font-heading" data-id="element-37">
            Pero, ¿cómo empezamos?
          </p>
        </div>
      </motion.div>
    </section>;
}